import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import PushDeviceManager from "./PushDeviceManager";
import { estratizaColors, estratizaGradients } from "../styles/estratizaTheme";

const NAV_ITEMS = [
  {
    label: "Chats",
    path: "/tickets",
    icon: active => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? estratizaColors.gold : "none"} stroke={active ? estratizaColors.goldLight : "rgba(255,255,255,0.55)"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    )
  },
  {
    label: "Contatos",
    path: "/contacts",
    icon: active => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? estratizaColors.goldLight : "rgba(255,255,255,0.55)"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    )
  },
  {
    label: "Menu",
    path: "__menu__",
    icon: active => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? estratizaColors.goldLight : "rgba(255,255,255,0.55)"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="3" y1="12" x2="21" y2="12" />
        <line x1="3" y1="6" x2="21" y2="6" />
        <line x1="3" y1="18" x2="21" y2="18" />
      </svg>
    )
  }
];

const MobileBottomNav = ({ onMenuOpen }) => {
  const history = useHistory();
  const location = useLocation();
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  if (!isMobile || location.pathname === "/login" || location.pathname === "/signup") {
    return null;
  }
  if (/^\/tickets\/\S+/.test(location.pathname)) return null;

  const isActive = path => location.pathname.startsWith(path);

  const handleTap = item => {
    if (item.path === "__menu__") {
      if (onMenuOpen) onMenuOpen();
      else window.dispatchEvent(new CustomEvent("mobile-open-menu"));
    } else if (item.path === "/tickets") {
      history.push("/tickets");
    } else {
      history.push(item.path);
    }
  };

  const navButtonStyle = {
    flex: 1,
    background: "none",
    border: "none",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 4px",
    gap: 3,
    minHeight: 60,
    transition: "opacity 0.15s",
    WebkitTapHighlightColor: "transparent",
    position: "relative"
  };

  const renderNavItem = item => {
    const active = item.path !== "__menu__" && isActive(item.path);
    return (
      <button
        key={item.path}
        type="button"
        onClick={() => handleTap(item)}
        style={navButtonStyle}
      >
        {item.icon(active)}
        <span
          style={{
            fontSize: 10,
            fontWeight: active ? 700 : 400,
            letterSpacing: 0.3,
            lineHeight: 1,
            color: active ? estratizaColors.goldLight : "rgba(255,255,255,0.55)"
          }}
        >
          {item.label}
        </span>
        {active && (
          <span
            style={{
              position: "absolute",
              top: 0,
              left: "20%",
              right: "20%",
              height: 3,
              borderRadius: "0 0 3px 3px",
              background: estratizaGradients.gold
            }}
          />
        )}
      </button>
    );
  };

  return (
    <nav
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1400,
        background: estratizaGradients.sidebar,
        borderTop: "1px solid rgba(212,175,55,0.24)",
        display: "flex",
        alignItems: "stretch",
        paddingBottom: "env(safe-area-inset-bottom)",
        boxShadow: "0 -2px 12px rgba(0,0,0,0.4)"
      }}
    >
      {renderNavItem(NAV_ITEMS[0])}
      {renderNavItem(NAV_ITEMS[1])}
      <div style={{ flex: 1, display: "flex" }}>
        <PushDeviceManager mobileNav />
      </div>
      {renderNavItem(NAV_ITEMS[2])}
    </nav>
  );
};

export default MobileBottomNav;
